module.exports = __webpack_public_path__ + "img/wizard-logo.c71f4470.png";